import { Component, Input, OnInit } from '@angular/core';

/*
 ** Use to put webp image as source ans fallback to original if not compatible
 ** The two image need to have the same name and location
 */

@Component({
  selector: 'app-picture',
  templateUrl: './picture.component.html',
  styleUrls: ['./picture.component.scss'],
  standalone: true,
})
export class PictureComponent implements OnInit {
  @Input() src: string;
  @Input() alt: string;
  @Input() convertToWebp = true;
  webpSrc: string;

  constructor() {}

  ngOnInit(): void {
    const splited = this.src.split('.');
    splited.pop();

    this.webpSrc = splited.join('.') + '.webp';
  }
}
